import store from '../../store'
import moment from 'moment'
import 'moment/locale/zh-cn'
// import { reportPdf } from '../../service'
const state = store.state
// const req_url = (state.env == 'development' ? '/api' : 'http://data-api.vcbeat.cn')
const req_url = state.req_url
const img_req_url = state.img_req_url
const static_img = state.static_img_url

const filter = {
  deal(p, dir, f = 'id', w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典
    if (state[dir] == '') {
      return a
    }
    let i = state[dir].findIndex((item) => item[f] == p)
    if (p + '' && i != -1) {
      return state[dir][i][w]
    } else {
      return a
    }
  },
  dealNeed(p, dir, w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典(按需加载时使用)
    let i = dir.findIndex((item) => item.id == p)
    if (p + '' && i != -1) {
      return dir[i][w]
    } else {
      return a
    }
  },
  dealName(p, dir, f = 'id', w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用数组
    if (dir && dir.length > 0) {
      let index = dir.findIndex((b) => b[f] == p)
      if (index > -1) {
        return dir[index][w]
      } else {
        return a
      }
    } else {
      return a
    }
  },
  addDeal(data_id, show = 1) {
    let address_arr = store.state.chinaAddressList
    if (address_arr.length && data_id && data_id != 0) {
      let index = address_arr.findIndex((a) => a.id == data_id)
      if (index > -1) {
        let item = address_arr[index]
        if (item.level == 1) {
          if (show == 1) {
            return item.name
          } else if (show == 2 || show == 3) {
            return false
          }
        }
        if (item.level == 2) {
          let idx = address_arr.findIndex((a) => a.id == item.pid)
          if (show == 1) {
            return address_arr[idx].name
          } else if (show == 2) {
            return item.name
          } else if (show == 3) {
            return false
          }
        }
        if (item.level == 3) {
          let idx1 = address_arr.findIndex((a) => a.id == item.pid)
          let idx2 = address_arr.findIndex((a) => a.id == item.gpid)

          if (show == 1) {
            return address_arr[idx2].name
          } else if (show == 2) {
            return address_arr[idx1].name
          } else if (show == 3) {
            return item.name
          }
        }
      } else {
        return '--'
      }
    } else {
      return '--'
    }
  },
  addressDeal(data_id, len = '1', arr, a = '--') { // 地址过滤  len 1显示 中国，2显示为 中国·重庆
    let address_arr = []
    if (arr && arr.length) {
      address_arr = arr
    } else {
      address_arr = state.address || []
    }
    if (data_id && data_id != '0' && address_arr.length) {
      let index = address_arr.findIndex((a) => a.id == data_id)
      let item = address_arr[index]
      if (item.gpid == null && item.pid == null) {
        return item.name
      }
      if (item.gpid == null && item.pid != null) {
        let idx = address_arr.findIndex((a) => a.id == item.pid)
        if (len == '1') {
          return address_arr[idx].name
        } else if (len == '2' || len == '3') {
          return address_arr[idx].name + '-' + item.name
        }
      }
      if (item.gpid != null && item.pid != null) {
        let idx = address_arr.findIndex((a) => a.id == item.id)
        let idx1 = address_arr.findIndex((a) => a.id == item.pid)
        let idx2 = address_arr.findIndex((a) => a.id == item.gpid)

        if (len == '1') {
          return address_arr[idx2].name
        } else if (len == '2') {
          return address_arr[idx2].name + '-' + address_arr[idx1].name
        } else if (len == '3') {
          return address_arr[idx2].name + '-' + address_arr[idx1].name + '-' + address_arr[idx].name
        }
      }
    } else {
      return a
    }
  },
  addressDtoDeal(data_id, address_arr = [], len = 3, joinStr = '-', name = 'name', a = '--') { // 地址过滤  len 1显示 中国，2显示为 中国·重庆
    if (data_id && data_id != '0' && address_arr.length) {
      let index = address_arr.findIndex((a) => a.id == data_id)
      let item = address_arr[index]
      console.log(item)
      if (!item.gpid && !item.pid) {
        return item[name]
      }
      if (!item.gpid && item.pid) {
        let idx = address_arr.findIndex((a) => a.id == item.pid)
        if (len == 1) {
          return address_arr[idx][name]
        } else if (len == 2 || len == 3) {
          return address_arr[idx][name] + joinStr + item[name]
        }
      }
      if (item.gpid && item.pid) {
        let idx = address_arr.findIndex((a) => a.id == item.id)
        let idx1 = address_arr.findIndex((a) => a.id == item.pid)
        let idx2 = address_arr.findIndex((a) => a.id == item.gpid)

        if (len == 1) {
          return address_arr[idx2][name]
        } else if (len == 2) {
          return address_arr[idx2][name] + joinStr + address_arr[idx1][name]
        } else if (len == 3) {
          return address_arr[idx2][name] + joinStr + address_arr[idx1][name] + joinStr + address_arr[idx][name]
        }
      }
    } else {
      return a
    }
  },
  dealString(p, dir, w = 'name') { // 基本过滤字符串,w表示返回字段,dir表示用哪一个字典
    if (state[dir] == '') {
      return '--'
    }
    if (p) {
      if (typeof (p) == 'object' && p.length == 0) {
        return '空'
      }
      let temp
      if (typeof (p) == 'object') {
        temp = p
      } else {
        temp = p.split(',')
      }
      // let temp = p.split(',')

      let arr = []
      for (let item of temp) {
        let index = state[dir].findIndex((item1) => item1.id + '' == item)
        if (index > -1) {
          arr.push(state[dir][index][w])
        }
      }
      return arr.join('、')
    } else {
      return '--'
    }
  },
  array2string(arr) {
    if (arr.length) {
      return arr.join('、')
    } else {
      return '--'
    }
  },
  empty(v, x = '--') { // 剔除空值的情况, x为想要显示的控制的参数
    return v ? v : x
  },
  time_moment(t, f = 'YYYY-MM-DD') { // 用moment处理时间
    if (t) {
      return moment(t).format(f)
    } else {
      return '--'
    }
  },
  time_standard(t) { // 用moment处理时间
    let time = moment(t)
    let now = moment()
    let du = moment.duration(now - time)._milliseconds
    if (du < 259200000) { // 三天
      return moment(t).fromNow()
    } else {
      return moment(t).format('YYYY-MM-DD')
    }
  },
  logo_show(path, route = '', default_img = '') { // 图片
    if (path && path != '--') {
      return img_req_url + path + route
    } else {
      return default_img
    }
  },
  amount_show(a) {
    if (a !== null && a !== undefined) {
      return a.toFixed(2)
    } else {
      return ''
    }
  },
  dealLanguage(zh, en) {
    if (!en) return zh || ''
    return state.language == 'en' ? en : zh
  }
}

export default filter
